import { buildImageProxyUrl } from '@repo/utils/url';

interface GetSrcSetUrlOptions {
  seoObjectName?: string;
  width?: number;
  height?: number;
}

export const getSrcSetUrl = (
  objectName: string,
  { seoObjectName, width, height }: GetSrcSetUrlOptions
): { '1x': string; '2x': string } => {
  return {
    '1x': buildImageProxyUrl(objectName, {
      seoObjectName: seoObjectName,
      width,
      height,
      scale: 1,
    }),
    '2x': buildImageProxyUrl(objectName, {
      seoObjectName: seoObjectName,
      width,
      height,
      scale: 2,
    }),
  };
};

export const srcSetToImage = (srcSet: Record<string, string>): string => {
  return Object.keys(srcSet)
    .map((key) => `${srcSet[key]} ${key}`)
    .join(', ');
};
